import React, { useEffect, useState } from 'react';
import { HistoryItem, getSwitchHistory } from '../../../api/cafAutomation';
import { Drawer } from '../Overlay';
import { HistoryList } from './formBits';

/** History of the AI switch, pause-all and the send limit (spec §5.6). */
export const SwitchHistoryDrawer: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [items, setItems] = useState<HistoryItem[] | null>(null);
  const [problem, setProblem] = useState('');
  useEffect(() => {
    let alive = true;
    getSwitchHistory().then(
      (data) => { if (alive) setItems(data.items); },
      () => { if (alive) setProblem("Couldn't load the history. Close and try again."); },
    );
    return () => { alive = false; };
  }, []);
  return (
    <Drawer eyebrow="Automation" title="History of the AI switch" onClose={onClose}>
      {!items && !problem
        ? <p className="cur-hint" role="status" aria-live="polite">Loading…</p>
        : <HistoryList items={items} problem={problem} empty="Nothing has changed yet." />}
    </Drawer>
  );
};
